/**
 * Partners Filtering
 */

var Partners = (function($) {

    function initPartnersOne() {

        var $gridOne = $('#partners-1').isotope({
        });
        
        var filters = {};

        $('.partner-filters--one .partner-filters__dropdown').click(function(){
            $(this).toggleClass('partner-filters__dropdown--expanded');
            $(this).next('.partner-filters__list').slideToggle();
            $('.partner-filters__dropdown').not(this).next().slideUp();
        });

        $('.partner-filters--one .partner-filters__list').on( 'click', '.partner-filters__item', function() {
            var $this = $(this);

            var $buttonGroup = $this.parents('.partner-filters__list');
            var filterGroup = $buttonGroup.attr('data-filter-group');

            filters[ filterGroup ] = $this.attr('data-filter');

            var filterValue = concatValues( filters );
            $gridOne.isotope({ filter: filterValue });

            if($this.hasClass('partner-filters__item--remove')){
                $this.parent().prev().find('.partner-filters__title').text(filterGroup);
                $this.hide();
            } else {
                var filterSelected = $this.text();
                $this.parent().prev().find('.partner-filters__title').text(filterSelected);
            }

            $this.toggleClass('partner-filters__item--selected');
            $this.siblings().removeClass("partner-filters__item--selected");
            $this.siblings(".partner-filters__item--remove").show();
            $this.parent().prev().toggleClass('partner-filters__dropdown--expanded');
            $this.parent().slideToggle();            

        });

        

        function concatValues( obj ) {
            var value = '';
            for ( var prop in obj ) {
                value += obj[ prop ];
            }
            return value;
        }
    }

    function initPartnersTwo() {

        var $gridTwo = $('#partners-2').isotope({
        });

        var filters = {};

        $('.partner-filters--two .partner-filters__dropdown').click(function(){
            $(this).toggleClass('partner-filters__dropdown--expanded');
            $(this).next('.partner-filters__list').slideToggle();
            $('.partner-filters__dropdown').not(this).next().slideUp();
        });

        $('.partner-filters--two .partner-filters__list').on( 'click', '.partner-filters__item', function() {
            var $this = $(this);

            var $buttonGroup = $this.parents('.partner-filters__list');
            var filterGroup = $buttonGroup.attr('data-filter-group');

            filters[ filterGroup ] = $this.attr('data-filter');

            var filterValue = concatValues( filters );
            $gridTwo.isotope({ filter: filterValue });

           if($this.hasClass('partner-filters__item--remove')){
                $this.parent().prev().find('.partner-filters__title').text(filterGroup);
                $this.hide();
            } else {
                var filterSelected = $this.text();
                $this.parent().prev().find('.partner-filters__title').text(filterSelected);
            }

            $this.toggleClass('partner-filters__item--selected');
            $this.siblings().removeClass("partner-filters__item--selected");
            $this.siblings(".partner-filters__item--remove").show();
            $this.parent().prev().toggleClass('partner-filters__dropdown--expanded');
            $this.parent().slideToggle();            


        });

        function concatValues( obj ) {
            var value = '';
            for ( var prop in obj ) {
                value += obj[ prop ];
            }
            return value;
        }
    }

    function initPartnersThree() {

        var $gridThree = $('#partners-3').isotope({
        });

        var filters = {};

        $('.partner-filters--three .partner-filters__dropdown').click(function(){
            $(this).toggleClass('partner-filters__dropdown--expanded');
            $(this).next('.partner-filters__list').slideToggle();
            $('.partner-filters__dropdown').not(this).next().slideUp();
        });

        $('.partner-filters--three .partner-filters__list').on( 'click', '.partner-filters__item', function() {
            var $this = $(this);

            var $buttonGroup = $this.parents('.partner-filters__list');
            var filterGroup = $buttonGroup.attr('data-filter-group');

            filters[ filterGroup ] = $this.attr('data-filter');

            var filterValue = concatValues( filters );
            $gridThree.isotope({ filter: filterValue });

            if($this.hasClass('partner-filters__item--remove')){
                $this.parent().prev().find('.partner-filters__title').text(filterGroup);
                $this.hide();
            } else {
                var filterSelected = $this.text();
                $this.parent().prev().find('.partner-filters__title').text(filterSelected);
            }

            $this.toggleClass('partner-filters__item--selected');
            $this.siblings().removeClass("partner-filters__item--selected");
            $this.siblings(".partner-filters__item--remove").show();
            $this.parent().prev().toggleClass('partner-filters__dropdown--expanded');
            $this.parent().slideToggle();            

        });

        function concatValues( obj ) {
            var value = '';
            for ( var prop in obj ) {
                value += obj[ prop ];
            }
            return value;
        }
    }

    function init() {

        if (!$('.page-template-template-partners').length) {
        return;
        }

        initPartnersOne();
        initPartnersTwo();
        initPartnersThree();
    }

    return {
        init: init
    };

}(jQuery));

jQuery(document).ready(Partners.init);
